/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { Injectable } from '@angular/core';

import {
  AbstractRestService,
  arrayOf,
  identity,
  RestSettings,
  SlicedDataSource,
} from '@gh/core-data';

import { Observable } from 'rxjs';
import { CheckUsageDto, CheckUsageMapper } from '../common';

import { BaseDesignDetails, BaseDesignFilterDto, BaseDesignListItemDto } from './base-design.dto';
import { BaseDesignDetailsMapper, BaseDesignListItemMapper } from './base-design.mapper';
import { ID } from '@gh/common-shared-data';

@Injectable()
export class BaseDesignRestService extends AbstractRestService {

  constructor(settings: RestSettings) {
    super(settings);
  }

  findAllAsDataSource(filter?: BaseDesignFilterDto): SlicedDataSource<BaseDesignListItemDto> {
    return this.createSlicedDataSourceGet(
      `${this.bp}/base-designs`,
      filter,
      identity(),
      arrayOf(BaseDesignListItemMapper));
  }

  create(baseDesign: BaseDesignListItemDto): Observable<BaseDesignListItemDto> {
    return this.httpPost(`${this.bp}/base-designs`, baseDesign, BaseDesignListItemMapper);
  }

  update(baseDesign: BaseDesignListItemDto): Observable<BaseDesignListItemDto> {
    return this.httpPut(`${this.bp}/base-designs/${baseDesign.id}`, baseDesign, BaseDesignListItemMapper);
  }

  undelete({ id, version }: BaseDesignListItemDto): Observable<BaseDesignListItemDto> {
    return this.httpPut(`${this.bp}/base-designs/undelete/${id}?version=${version}`, void 0, BaseDesignListItemMapper);
  }

  deactivateOrDelete(baseDesign: BaseDesignListItemDto, checkUsage: CheckUsageDto): Observable<BaseDesignListItemDto> {
    return this.httpDelete(`${this.bp}/base-designs/${baseDesign.id}`, checkUsage, identity(), BaseDesignListItemMapper);
  }

  checkUsage({ id, version }: BaseDesignListItemDto): Observable<CheckUsageDto> {
    return this.httpGet(`${this.bp}/base-designs/check-usage/${id}`, { version }, void 0, CheckUsageMapper);
  }

  get(id: ID): Observable<BaseDesignDetails> {
    return  this.httpGet(`${this.bp}/base-designs/${id}`, BaseDesignDetailsMapper);
  }
}
